import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FlexLayoutModule} from "@angular/flex-layout";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {provideNgxMask} from "ngx-mask";
import {BaseModule} from "../base-module/base.module";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgChartsModule } from "ng2-charts";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { ListaPrevidenciaComponent } from "./lista-previdencia/lista-previdencia.component";
import { RendaFixaRoutesModule } from "./previdencia.routing";
import { CadastroBoletaPrevidenciaComponent } from "./cadastro-boleta-previdencia/cadastro-boleta-previdencia.component";
import { UploadPrevComponent } from "./upload-prev/upload-prev.component";

/** Services */
import { CaracteristicaPrevidenciaService } from "./services/caracteristica-previdencia.service";
import { BoletaPrevidenciaService } from "./services/boleta-previdencia.service";
import { MovimentacaoModule } from "app/movimentacao/movimentacao.module";
import { ClienteService } from "app/clientes/services/cliente.service";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatListModule } from "@angular/material/list";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMenuModule } from "@angular/material/menu";
import { MatChipsModule } from "@angular/material/chips";
import { FileUploadModule } from "ng2-file-upload";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
    imports: [        
        CommonModule,
        RendaFixaRoutesModule,
        MovimentacaoModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatAutocompleteModule,
        BaseModule,
        FileUploadModule,
        MatSelectModule,
        MatOptionModule,
        MatTabsModule,
        MatRadioModule,
        MatDatepickerModule,
        MatSelectModule,        
        CurrencyMaskModule,
        MatMenuModule,
        MatChipsModule,
        NgxChartsModule,
        NgChartsModule,
        FuseWidgetModule,
        DragDropModule
    ],
    declarations: [
        ListaPrevidenciaComponent,
        CadastroBoletaPrevidenciaComponent,
        UploadPrevComponent
    ],
    providers: [
        CaracteristicaPrevidenciaService,
        BoletaPrevidenciaService,
        ClienteService,
        provideNgxMask()
    ],
    
})
export class PrevidenciaModule { }
